import React, { createContext, useContext, useState } from 'react';

const PaymentContext = createContext(null);

export const PaymentProvider = ({ children }) => {
    const [paymentStatus, setPaymentStatus] = useState({
        isProcessing: false,
        error: null,
        success: false,
        paymentId: null,
        amount: null
    });

    const resetPaymentStatus = () => {
        setPaymentStatus({
            isProcessing: false,
            error: null,
            success: false,
            paymentId: null,
            amount: null
        });
    };

    const updatePaymentStatus = (newStatus) => {
        setPaymentStatus(prevStatus => ({
            ...prevStatus,
            ...newStatus
        }));
    };

    const value = {
        paymentStatus,
        updatePaymentStatus,
        resetPaymentStatus
    };

    return (
        <PaymentContext.Provider value={value}>
            {children}
        </PaymentContext.Provider>
    );
};

export const usePayment = () => {
    const context = useContext(PaymentContext);
    if (!context) {
        throw new Error('usePayment doit être utilisé avec PaymentProvider');
    }
    return context;
};